import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider } from "@mui/material";
import { Fragment } from "react";
import { FormFields } from "./index.js";
export const FormFieldsGroups = ({ schemas, formFieldProps, autoFocus, }) => (_jsx(_Fragment, { children: schemas.map((schema, index) => (_jsxs(Fragment, { children: [Boolean(index) && (_jsx(Divider, { sx: {
                    width: ({ spacing }) => `calc(100% + ${spacing(2)})`,
                    pt: 2,
                    mr: -2,
                } })), _jsx(FormFields, { ...formFieldProps, schema: schema, autoFocus: autoFocus && index === 0 })] }, index.toString()))) }));
//# sourceMappingURL=FormFieldsGroups.js.map